import { SERVER_URL } from '../utils/constants';

const getAudiobook = async (pozId) => {
  const response = await fetch(`${SERVER_URL}/getCurrentAudiobook?pozId=${pozId}`)
  return response.json()

}
export default getAudiobook
